import { FiltersTranslationsKeys } from '@epicuro-next/models/product-filters';

const seasonFilterLocale = $localize`:productBasket|Translation for season filter@@seasonFilterName:Season`;
const subcategoryFilterLabel = $localize`:productBasket|Translation for categoryname filter@@subcategorynameFilterName:Sub Category`;

const presetFilterLabel = $localize`:productBasket|Translation for preset filter@@presetFilterName:Quick filters`;
const brandFilterLabel = $localize`:productBasket|Translation for brand filter@@brandFilterName:Brand`;
export const maindistributionchannelFilterLabel = $localize`:productBasket|Translation for dc filter@@dcFilterName:DC`;
const productdivisionFilterLabel = $localize`:productBasket|Translation for product division filter@@productDivisionFilterName:Division`;
const categoryFilterLabel = $localize`:productBasket|Translation for category filter@@categoryFilterName:Category`;
const genderFilterLabel = $localize`:productBasket|Translation for gender filter@@genderFilterName:Gender`;
const ageFilterLabel = $localize`:productBasket|Translation for Age filter@@ageFilterName:Age`;
const agegroupFilterLabel = $localize`:productBasket|Translation for agegroup filter@@agegroupFilterName:Age Group`;
const colormaincolorgroupFilterLabel = $localize`:productBasket|Translation for color main group filter@@colorMainColorGroupFilterName:Color`;
const colorFilterLabel = $localize`:productBasket|Translation for color filter@@colorFilterName:Color`;
const colorrangetypesFilterLabel = $localize`:productBasket|Translation for color range types filter@@colorRangeTypesFilterName:Color Range Types`;
const deliveryDateFilterLabel = $localize`:productBasket|Translation for deliverydate filter@@deliverydateFilterName:Delivery Date`;
const featureFilterLabel = $localize`:productBasket|Translation for feature filter@@featureFilterName:Feature`;
export const wholesalePriceFilterLabel = $localize`:productBasket|Translation for wholesale price range filter@@wholesalePriceRangeFilterName:WSP`;
export const retailPriceFilterLabel = $localize`:productBasket|Translation for rrp filter@@rrpFilterName:RRP`;
const catalogFilterLabel = $localize`:productBasket|Translation for catalogs filter@@catalogsFilterName:Catalogs`;
export const sizeFilterLabel = $localize`:productBasket|Translation for size filter@@sizeFilterName:Size`;
export const shapeLengthFilterLabel = $localize`:productBasket|Translation for shape length filter@@shapeLengthFilterName:Shape Length`;

export const articletypeFilterLabel = $localize`:productBasket|Translation for article type filter@@articleTypeFilterName:Article Type`;
export const articlegroupFilterLabel = $localize`:productBasket|Translation for article group filter@@articleGroupFilterName:Article Group`;
export const linenameFilterLabel = $localize`:productBasket|Translation for line name filter@@lineNameFilterName:Line Name`;
export const activitygroupFilterLabel = $localize`:productBasket|Translation for activity group filter@@activityGroupFilterName:Activity Group`;
export const isclosedoutproductFilterLabel = $localize`:productBasket|Translation for closed out filter@@CloseOutFilterName:Close-out`;
export const keyarticlesFilterLabel = $localize`:productBasket|Translation for key articles filter@@KeyArticlesFilterName:Key Articles`;

export const isdFilterLabel = $localize`:productBasket|Translation for isd filter@@isdDatesFilterName:In Store Date`;
export const marketingSupportFilterLabel = $localize`:productBasket|Translation for isd filter@@marketingSupportFilterName:Marketing Support`;
const materialFilterLabel = $localize`:productBasket|Translation for material filter@@materialFilterName:Material`;
const productFilterLabel = $localize`:productBasket|Translation for product filter@@productFilterName:Product`;
const fitFilterLabel = $localize`:productBasket|Translation for fit filter@@fitFilterName:Fit`;
const typeFilterLabel = $localize`:productBasket|Translation for Type filter@@typeFilterName:Type`;
const widthFilterLabel = $localize`:productBasket|Translation for width filter@@widthFilterName:Width`;
const inventoryRangeFilterLabel = $localize`:productBasket|Translation for inventory range filter@@inventoryRangeFilterName:Available Quantities`;
export const filterLabelsByTranslationKey: {
  [key in FiltersTranslationsKeys]: string;
} = {
  [FiltersTranslationsKeys.ProductSearch_Filter_Age]: ageFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_AgeGroup]: agegroupFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_ActivityGroup]:
    activitygroupFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_ArticleType]:
    articletypeFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_ArticleGroup]:
    articlegroupFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Brand]: brandFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Catalog]: catalogFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Category]: categoryFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Colour]: colorFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_DeliveryDate]:
    deliveryDateFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Division]:
    productdivisionFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Feature]: featureFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Fit]: fitFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Gender]: genderFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Isd]: isdFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_IsClosedOutProduct]:
    isclosedoutproductFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_KeyArticles]:
    keyarticlesFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_LineName]: linenameFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_MarketingSupport]:
    marketingSupportFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_MainColor]:
    colormaincolorgroupFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_MainDistributionChannel]:
    maindistributionchannelFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Material]: materialFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Preset]: presetFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Product]: productFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_RRP]: retailPriceFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Size]: sizeFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Shapelength]:
    shapeLengthFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Season]: seasonFilterLocale,
  [FiltersTranslationsKeys.ProductSearch_Filter_Subbrand]: brandFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Subcategory]:
    subcategoryFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Type]: typeFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_WSP]: wholesalePriceFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Width]: widthFilterLabel,
  [FiltersTranslationsKeys.ProductSearch_Filter_Inventory]:
    inventoryRangeFilterLabel,
};

// each key corresponds to a facetId
// Deprecated for search filters v2 as filter id comes dynamic, use translation key instead (searchFilterByTranlationKeyLabels)
export const filterLabelsById: Record<string, string> = {
  preset: presetFilterLabel,
  subsite: $localize`:productBasket|Translation for subsite filter@@subsiteFilterName:Brand`,
  specialty: $localize`:productBasket|Translation for specialty filter@@specialtyFilterName:Specialty`,
  availability: $localize`:productBasket|Translation for availability filter@@availabilityFilterName:Delivery Month`,
  maxAge: $localize`:productBasket|Translation for maxAge filter@@maxAgeFilterName:Arrival Time`,
  categoryname: $localize`:productBasket|Translation for categoryname filter@@categorynameFilterName:Category`,
  deliverydate: deliveryDateFilterLabel,
  subcategory: subcategoryFilterLabel,
  subcategoryname: subcategoryFilterLabel,
  mastercategoryname: $localize`:productBasket|Translation for categoryname filter@@mastercategorynameFilterName:Category`,
  mastersubcategoryname: $localize`:productBasket|Translation for subcategoryname filter@@mastersubcategorynameFilterName:Sub Category`,
  isglobalnoos: $localize`:productBasket|Translation for isglobalnoos filter@@isglobalnoosFilterName:NOOS`,
  gender: genderFilterLabel,
  sustainablestyles: $localize`:productBasket|Translation for sustainablestyles filter@@sustainablestylesFilterName:Sustainable Styles`,
  color: colorFilterLabel,
  colorrangetypes: colorrangetypesFilterLabel,
  retailPriceRange: retailPriceFilterLabel,
  division: $localize`:productBasket|Translation for division filter@@divisionFilterName:Division`,
  agegroup: agegroupFilterLabel,
  maincolor: $localize`:productBasket|Translation for maincolor filter@@maincolorFilterName:Main Color`,
  dc: maindistributionchannelFilterLabel,
  category: categoryFilterLabel,
  brandname: brandFilterLabel,
  brand: brandFilterLabel,
  material: materialFilterLabel,
  bodywear: $localize`:productBasket|Translation for bodywear filter@@bodywearFilterName:Bodywear`,
  occasion: $localize`:productBasket|Translation for occasion filter@@occasionFilterName:Occasion`,
  core__category: $localize`:productBasket|Translation for core category filter@@core__categoryFilterName:Category`,
  materialgroup: $localize`:productBasket|Translation for material group filter@@materialGroupFilterName:Type`,
  size: sizeFilterLabel,
  product: productFilterLabel,
  season: seasonFilterLocale,
  styleseason: seasonFilterLocale,
  productdivision: productdivisionFilterLabel,
  colormaincolorgroup: colormaincolorgroupFilterLabel,
  catalog: catalogFilterLabel,
  width: widthFilterLabel,
  fit: fitFilterLabel,
  inventoryRange: $localize`:productBasket|Translation for Available Quantities filter@@inventoryRangeFilterName:Available Quantities`,
  countryoforigincountryoforiginname: $localize`:productBasket|Translation for Country of Origin filter@@countryoforiginFilterName:Country of origin`,
  age: ageFilterLabel,
  typefilter: typeFilterLabel,
  inseam: $localize`:productBasket|Translation for Inseam filter@@inseamFilterName:Width`,
  priceRange: $localize`:productBasket|Translation for price range filter@@priceRangeFilterName:Price Range`,
  isdDates: isdFilterLabel,
  articletype: articletypeFilterLabel,
  linename: linenameFilterLabel,
  activitygroup: activitygroupFilterLabel,
  strategictype: $localize`:productBasket|Translation for license filter@@licenseGroupFilterName:License`,
  isclosedoutproduct: isclosedoutproductFilterLabel,
  keyarticles: keyarticlesFilterLabel,
  feature: featureFilterLabel,
  excludeProductReferences: $localize`:CMI|Translation for selection filter@@excludeProductReferencesFilterName:Selection`,
  filterOutInbound: $localize`:productBasket|Translation for inbound filter@@inboundFilterName:Inbound`,
  filterOutRecentlyDelivered: $localize`:productBasket|Translation for recently delivered filter@@recentlyDeliveredFilterName:Recently Delivered`,
};
